__turbopack_context__.v({
  "root": "GradientText-module__gaWssW__root",
});
